import axios from "../../../utils/authAxios";
const api_base_url = process.env.REACT_APP_API_BASEURL;

export const getPolicyTerms = async () => {
  const { data } = await axios.get(
    `${api_base_url}/PolicyFeeConfiguration/PolicyTerm`
  );
  return data;
};
export const getFeeType = async () => {
  const { data } = await axios.get(
    `${api_base_url}/PolicyFeeConfiguration/FeeType`
  );
  //const { data } = await axios.get("https://localhost:44399/api/TargetSyStem");
  return data;
};

// Update PolicyType
export const updateFeeType = async (updateFeeType) => {
  return await axios.put(
    `${api_base_url}/PolicyFeeConfiguration/UpdateFeeType/${updateFeeType.feeTypeId}`,
    updateFeeType
  );
};

//Delete Fee Type
export const deleteFeeType = async (FeeTypeIds) => {
  await axios.delete(
    `${api_base_url}/PolicyFeeConfiguration/FeeType${FeeTypeIds}`,
    {
      data: FeeTypeIds,
    }
  );
};

//Insert New Fee Type
export const addFeeType = async (newFeeType) => {
  const newOfficeStatusData = {};
  const { data } = await axios.post(
    `${api_base_url}/PolicyFeeConfiguration/AddFeeType`,
    newFeeType
  );
  return data;
};

export const updatePolicyTerm = async (updatedPolicyTermData) => {
  return await axios.put(
    `${api_base_url}/PolicyFeeConfiguration/PolicyTerm/${updatedPolicyTermData.policyTermId}`,
    updatedPolicyTermData
  );
};

export const addPolicyTerm = async (newPolicyTerm) => {
  const { data } = await axios.post(
    `${api_base_url}/PolicyFeeConfiguration/PolicyTerm`,
    newPolicyTerm
  );
  return data;
};

//Delete Policy Term
export const deletePolicyTerms = async (TermIds) => {
  await axios.delete(
    `${api_base_url}/PolicyFeeConfiguration/PolicyTerm${TermIds}`,
    {
      data: TermIds,
    }
  );
};
